module.exports = __webpack_public_path__ + "static/media/pic15.e3af8410.jpg";